/**
 * The Rapid Fusion icon set: public/images/icons/<name>.svg (white line art; your website
 * icons plus matching ones drawn for the KC). Drawn in RF plum with the .rf-icon class
 * (rf-design-system.css), so the colour comes from the design tokens.
 * Add an icon: drop <name>.svg in public/images/icons/ and add the name here.
 */
export const RF_ICONS = ['book','box','building','calendar-check','chat','checklist','circuit','clipboard-check','cloud','cost-chart','factory','folder','globe','graduation-cap','home','id-badge','inspect','invoice','key','layers','lifebuoy','lightning','partners','people','pound','presentation','printer-3d','procedure','process-flow','robot-arm','ruler','settings','shield-check','ship','speed','supply','tag','target','thermal','wrench'];

export const isRfIcon = (name) => typeof name === 'string' && RF_ICONS.includes(name);

export const rfIconStyle = (name) => ({ '--rf-icon': `url('/images/icons/${name}.svg')` });
